import type { SVGProps } from "react";
export interface Globe01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Globe01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Globe01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.875 12q-.002-.968-.075-1.874H9.2a23.6 23.6 0 0 0 0 3.75h5.6q.073-.907.075-1.875Zm-5.372 4.125c.185.955.426 1.81.714 2.529.33.826.695 1.419 1.043 1.787.345.365.596.433.74.434.143 0 .393-.068.74-.434.347-.368.713-.961 1.044-1.787.287-.72.527-1.574.712-2.529zm2.496-13c-.143 0-.394.068-.74.434-.348.368-.712.962-1.042 1.788-.288.72-.53 1.574-.714 2.528h4.993c-.185-.954-.425-1.809-.712-2.528-.33-.826-.697-1.42-1.045-1.788-.346-.366-.596-.434-.74-.434m5.126 8.876c0 .637-.027 1.264-.072 1.875H21.5l.115.005a1.126 1.126 0 0 1 0 2.239l-.114.005h-4.714c-.214 1.25-.525 2.39-.914 3.364-.394.983-.89 1.855-1.499 2.499-.611.646-1.413 1.137-2.375 1.137-.96 0-1.763-.491-2.374-1.137-.609-.644-1.105-1.516-1.499-2.5-.39-.974-.698-2.113-.912-3.363H2.5a1.125 1.125 0 0 1 0-2.25h4.446a26 26 0 0 1-.07-1.874q.002-.958.07-1.875H2.5a1.125 1.125 0 0 1 0-2.25h4.714c.214-1.25.523-2.39.912-3.365.394-.983.89-1.854 1.499-2.498.611-.646 1.413-1.138 2.374-1.138s1.764.492 2.375 1.138c.609.644 1.105 1.515 1.499 2.498.39.975.7 2.115.914 3.364H21.5l.115.006a1.126 1.126 0 0 1 0 2.239l-.114.006h-4.448c.044.61.072 1.237.072 1.875"
      />
      <path
        fill={color}
        d="M20.875 12a8.876 8.876 0 1 0-17.752.001 8.876 8.876 0 0 0 17.752 0Zm2.25 0c0 6.144-4.982 11.124-11.126 11.125S.875 18.145.875 12 5.855.875 11.999.875s11.126 4.981 11.126 11.126Z"
      />
    </svg>
  );
}
